import ModalContent from './ModalContent';
import modalContentStyles from './modalContent.module.scss';

export { ModalContent, modalContentStyles };

export default ModalContent;
